// Approval level identifiers used by approveReject.js business logic.
// These are NOT Bouncer keys — they map invoice approval states to level names.
export const PERMISSIONS = {
  vm_approval: "vm_approval",
  l1_approval: "l1_approval",
  l2_approval: "l2_approval",
  deny: "deny",
};
